// トグル(アコーディオン)表示
import commonClass from "./commonClass";

export default class tooltipClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {

  }
  // class変数定義
  _classValiableDefine() {
    this._tgt = '.js-tooltip';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    $(cls._tgt).tooltip({
      trigger: "click",
    });
  }

}